module.exports = __webpack_public_path__ + "static/media/logo_color_small.fe989e5e.png";